export const FIND_POOL_REQUESTS_REQUEST = 'FIND_POOL_REQUESTS_REQUEST';

export const findPoolRequestsRequest = ({
     filter = [],
     sorting = { field: 'title', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }) => ({
    type: FIND_POOL_REQUESTS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
        pagination,
    }
});
